import { render, staticRenderFns } from "./FieldConsent.vue?vue&type=template&id=baf682c0"
import script from "./FieldConsent.vue?vue&type=script&lang=js"
export * from "./FieldConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports